import '../css/DynamicForm.css';
import React, { useState, useRef, useEffect } from "react";
import { Fetchexecutequery } from '../../../services/process/BRS1/brsService7';
import axios from "axios";
import Select from "react-select";
import { components } from "react-select";
import { headers, baseUrl } from "../../../services/common/credentials";


export const DYNAMIC_FORM_FONT = "'Inter', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, sans-serif";


const DynamicForm = ({ fields, formData, onInputChange, onSubmit }) => {
  console.log("fields",fields)
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100;
    const endYear = currentYear + 100;
    return Array.from(new Array(endYear - startYear + 1), (v, i) => startYear + i);
  };
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions_1,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [dataDisplayers, setDataDisplayers] = useState({});
  const [fileUploads, setFileUploads] = useState({});


  const validateField = (value, type) => {
    if (!type) return true;

    switch (type.value) {
      case "text":
        return true;
      case "integer":
        return /^-?\d*$/.test(value);
      case "decimal":
        return /^-?\d*\.?\d*$/.test(value);
      case "date":
        return !isNaN(Date.parse(value));
      default:
        return true;
    }
  };

  const handleFileUpload = async (e, columnName, file_path) => {
    const file = e.target.files[0];
    if (file) {
      const sharedFilePath = `${file_path}`;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("filePath", sharedFilePath);

      try {
        const response = await fetch(`${baseUrl}/api/v2/user_modules/upload/`, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          const backendFileName = data.Filename;

          setFileUploads((prevState) => ({
            ...prevState,
            [columnName]: {
              fileName: backendFileName,
              filePath: data.Filepath,
            },
          }));

          onInputChange(columnName, backendFileName);
          console.log('File uploaded successfully:', data.Filepath, data.Filename);
        } else {
          const errorData = await response.json();
          console.error('Error uploading file:', errorData.Message || 'Unknown error');
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };
const buildFilterWhereClause = (customFilters, globalFilters) => {
  if (!customFilters?.length || !globalFilters?.length) return '';

  const activeFilters = globalFilters[0]; // your state has single object

  const clauses = customFilters
    .map(({ value }) => {
      if (activeFilters[value] !== undefined && activeFilters[value] !== null) {
        return `${value} = '${activeFilters[value]}'`;
      }
      return null;
    })
    .filter(Boolean);

  return clauses.length ? ' AND ' + clauses.join(' AND ') : '';
};

useEffect(() => {
  if (fields && Array.isArray(fields)) {
    fields.forEach((field) => {
      if (field.function === 'Data Displayer with reference') {

        const referenceField = field.customOptions?.inputFieldDropdown2?.value;
        const fetchField = field.customOptions?.fetchfield?.value ?? null;
        const referenceValue = referenceField ? formData[referenceField] : null;

        console.log(referenceField,fetchField,referenceValue,field)
        if (referenceValue) {
          fetchDataForDataDisplayer(referenceField, referenceValue, field.columnName, field.customOptions,fetchField)
            .then((dataDisplayerValue) => {
              if (dataDisplayers[field.columnName] !== dataDisplayerValue) {
                setDataDisplayers(prevState => ({
                  ...prevState,
                  [field.columnName]: dataDisplayerValue
                }));
                onInputChange(field.columnName, dataDisplayerValue);
              }
            });
        } else {
          // If referenceField or its value doesn't exist, set as null
          if (dataDisplayers[field.columnName] !== null) {
            setDataDisplayers(prevState => ({
              ...prevState,
              [field.columnName]: null
            }));
            onInputChange(field.columnName, null);
          }
        }
      }
    });
  }
}, [formData, fields, dataDisplayers]);

const fetchDataForDataDisplayer = async (
  referenceField,
  referenceValue,
  columnName,
  customOptions,
  fetchfield
) => {

  const column = fetchfield ?? columnName;

  const dynamicFilterClause = buildFilterWhereClause(
    customOptions?.filterconditions,
    filterconditions_1
  );

  const payload = {
    query: `
      SELECT ${column}
      FROM ${customOptions.inputFieldDropdown.value}.${customOptions.inputFieldDropdown1.value}
      WHERE ${referenceField} = '${referenceValue}'
      ${dynamicFilterClause};
    `
  };

  const [headers, url] = Fetchexecutequery();

  try {
    const response = await axios.post(url, payload, headers);
    const data = response.data;
    return data?.length ? data[0][column] : null;
  } catch (error) {
    console.error("Error fetching data for Data Displayer", error);
    return null;
  }
};

  const formatFieldName = (name, renameValue = '') => {
    const finalName = renameValue || name;
    return finalName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  };

const handleFieldChange = (e, fieldType) => {
  if (!e?.target) return;

  const { name, value, tagName } = e.target;
  const isValid = validateField(value, fieldType);

  if (isValid) {
    onInputChange(name, value);
  } else {
    alert(
      `Invalid input for ${fieldType.label}. Please enter a valid ${fieldType.label.toLowerCase()}.`
    );
    return;
  }

  // ? Apply height adjustment ONLY for textarea
  if (tagName === "TEXTAREA") {
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }
};

  return (
    <form onSubmit={onSubmit} className="dynamic-form">
      {fields && fields.map((field, index) => {
        const widthClass = field.width ? `width-${field.width.value}` : 'width-m';

        return (
          <div key={index} className={`form-group ${widthClass}`}>
            <label className="form-label">{formatFieldName(field.columnName, field.renameValue)}:</label>
            <div className="form-input">
              {field.function === 'Input Field' && (
                <textarea
                  type="text"
                  name={field.columnName}
                  maxLength={field.maxDigits}
                  value={formData[field.columnName] || ''}
                  onChange={(e) => handleFieldChange(e, field.type)}
                  style={{ resize: "none", overflow: "hidden", fontFamily: DYNAMIC_FORM_FONT }}
                />
              )}


              {field.function === "Dropdown" && (
  <Select
  name={field.columnName}
  placeholder={`Select ${(field.renameValue || field.columnName).replace(/_/g, " ")}`}
  value={
    field.options.find(
      opt => opt.value === formData[field.columnName]
    ) || null
  }
  options={field.options}
  isSearchable
  isClearable
  onChange={(selectedOption) =>
    handleFieldChange({
      target: {
        name: field.columnName,
        value: selectedOption?.value || ""
      }
    }, field)
  }
  styles={{
    container: (base) => ({
      ...base,
      width: "100%",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    control: (base, state) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderColor: state.isFocused ? "#f97316" : "#d4dce8",
      borderRadius: "8px",
      minHeight: "42px",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(249,115,22,.12)" : "0 1px 3px rgba(10,35,82,.08)",
      transition: "border-color 0.18s ease, box-shadow 0.18s ease",
      fontFamily: DYNAMIC_FORM_FONT,
      "&:hover": {
        borderColor: "#f97316",
      },
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "10px 12px",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    singleValue: (base) => ({
      ...base,
      color: "#0f172a",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    input: (base) => ({
      ...base,
      color: "#0f172a",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    placeholder: (base) => ({
      ...base,
      color: "#64748b",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 8px 30px rgba(10,35,82,.14)",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "rgba(249,115,22,.12)"
        : state.isFocused
        ? "rgba(249,115,22,.08)"
        : "#ffffff",
      color: "#0f172a",
      cursor: "pointer",
      fontFamily: DYNAMIC_FORM_FONT,
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#64748b",
    }),

    clearIndicator: (base) => ({
      ...base,
      color: "#64748b",
    }),

  indicatorSeparator: () => ({
    display: "none",
  }),
}}
/>

)}
{field.function === 'Data Displayer with reference' && (
  <span
    className="data-displayer-box"
    title={dataDisplayers[field.columnName] ? dataDisplayers[field.columnName] : undefined}
  >
    {dataDisplayers[field.columnName] || ''}
  </span>
)}

{field.function === 'Data Displayer' && (
  <span
    className="data-displayer-box"
    title={formData?.[field.columnName] ? formData[field.columnName] : undefined}
  >
    {formData?.[field.columnName] ?? ''}
  </span>
)}

              {field.function === 'File Upload' && (
                <input
                  type="file"
                  name={field.columnName}
                  onChange={(e) => handleFileUpload(e, field.columnName, field.customOptions.filePath)}
                />
              )}

              {field.function === 'Date Field' && (
                <>
                  {field.dateFormat === 'month' ? (
                    <input
                      type="month"
                      name={field.columnName}
                      value={formData[field.columnName] || ''}
                      onChange={handleFieldChange}
                    />
                  ) : field.dateFormat === 'year' ? (
                    <select
                      name={field.columnName}
                      value={formData[field.columnName] || ''}
                      onChange={handleFieldChange}
                    >
                      {generateYearOptions().map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="date"
                      name={field.columnName}
                      value={formData[field.columnName] || ''}
                      onChange={handleFieldChange}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        );
      })}
    </form>
  );
};

export default DynamicForm;
